<template>
  <div
    class="lcu-dashboard-wrap"
    :class="{
      'lcu-dashboard-pageIOS': _device.iPhone && _device.app,
      }">
    <AuthNav />
    <IphoneBar />
    <MobileControls />
    <div class="lcu-dashboard" id="lcu-dashboard">
      <router-view v-if="user.id" />
    </div>
    <Footer />
  </div>
  <NetworkModal />
</template>

<script>
import { mapGetters } from 'vuex';
import Auth from '@/mixins/Auth.vue';
import Footer from 'ç/footer/Footer.vue';
import AuthNav from 'ç/nav/AuthNav.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import NetworkModal from 'ç/network-modal/NetworkModal.vue';

export default {
  name: 'portal-page',
  mixins: [Auth],
  computed: {
    ...mapGetters([
      'user',
      'userLoading',
      'networkModal',
      'userLoadAttempted',
    ]),
  },
  emits: ['load-user'],
  components: {
    MobileControls,
    IphoneBar,
    NetworkModal,
    AuthNav,
    Footer,
  },
  methods: {
    checkRoute() {
      const authRoute = this.$router.currentRoute.value?.meta?.auth ? '/iniciar-sesion' : '/tablero-de-control';
      this.$router.push(authRoute);
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-dashboard-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: $private-nav-height;
}

.lcu-dashboard {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  @media screen and (min-width: $tablet-min) {
    grid-template-columns: 1fr;
  }
}

.lcu-dashboard-space {
  display: none;

  @media screen and (min-width: $tablet-min) {
    display: block;
  }
}

.lcu-dashboard-pageIOS {

  @media only screen and (max-width: $mobile-max) {
    padding-bottom: 20px;
    padding-top: 105px;
  }

  @include ipad-pro-12 {
    padding-top: 100px;
  }
}
</style>
